module.exports = __webpack_public_path__ + "static/img/img5.38b1c2d0.png";